import React, { useEffect, useState } from 'react';
import _get from 'lodash/get';

// Components
import Terminology from 'components/Terminology';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';

// Styles
import withStyles from '@material-ui/core/styles/withStyles';
import { defineStyles, Classes } from 'styles/defineStyles';

const styles = defineStyles(theme => {
  return {
    title: {
      width: 500,
    },
    formControlLabel: {
      maxWidth: theme.spacing(12),
    },
    row: {
      marginBottom: theme.spacing(2),
    },
    radioRow: {
      display: 'flex',
      alignItems: 'center',
      fontSize: 16,
    },
    radioGroup: {
      flexDirection: 'row',
      marginLeft: theme.spacing(2),
      minWidth: 140,
      maxWidth: 240,
      width: '100%',
      justifyContent: 'space-around',
    },
    subTitle: {
      fontSize: 13,
      color: theme.palette.secondary.main,
      marginTop: theme.spacing(0.5),
    },
  };
});

interface Props {
  onChange: (newAttribute: any) => void;
  classes: Classes<typeof styles>;
  attribute?: any;
}
//TODO Tyler: This Component has weird state issues. In AttributesEdit, if valueREadOnly is false,
//  and you cannot display on team member profiles, if you switch to yes,
// the hit cancel, it reverts state. If valueReadOnly is true, it does not revert to original state.
function AttributeRadioForm(props: Props) {
  const { classes, onChange, attribute } = props;

  const attributeConnectDisplayed = _get(attribute, 'connectDisabled', false);
  const attributeValueReadOnly = _get(attribute, 'valueReadOnly', false);
  const attributeCanBePrivatized = _get(attribute, 'valueCanBePrivatized', false);

  // FormControlValues do not support booleans. So this cast function is requires to cast the string to boolean
  const castBool = (stringToBool: 'true' | 'false') => {
    if (stringToBool === 'true') {
      return true;
    }
    return false;
  };

  return (
    <>
      <div className={classes.radioRow}>
        <div className={classes.title}>
          {/* Display on <Terminology term={'teamMember'} casing="lowercase" /> profiles */}
          Enable attribute (if disabled, will not appear anywhere in Sift)
        </div>
        <RadioGroup
          aria-label="Enable attribute (will be visible on profile pages and elsewhere in Sift)"
          name="connectDisabled"
          className={classes.radioGroup}
          value={attributeConnectDisplayed.toString()} /* Radio Group only accepts strings */
          onChange={(e: any) => onChange({ connectDisabled: castBool(e.target.value) })}
        >
          <FormControlLabel
            className={classes.formControlLabel}
            value={'false'}
            control={<Radio />}
            label="Yes"
          />
          <FormControlLabel value="true" control={<Radio />} label="No" />
        </RadioGroup>
      </div>

      <div className={classes.radioRow}>
        <div className={classes.title}>
          Allow <Terminology term="teamMember_plural" casing="lowercase" /> to edit attribute
          content
          <div className={classes.subTitle}>
            <strong>Note: </strong>
            Users will not be able to edit data if it is mapped from a data source.
          </div>
        </div>
        <RadioGroup
          aria-label="Edit Permission"
          name="valueReadOnly"
          className={classes.radioGroup}
          value={attributeValueReadOnly.toString()} /* Radio Group only accepts strings */
          onChange={(e: any) => onChange({ valueReadOnly: castBool(e.target.value) })}
        >
          <FormControlLabel
            className={classes.formControlLabel}
            value="false"
            control={<Radio />}
            label="Yes"
          />
          <FormControlLabel value="true" control={<Radio />} label="No" />
        </RadioGroup>
      </div>

      <div className={classes.radioRow}>
        <div className={classes.title}>
          Allow <Terminology term="teamMember_plural" casing="lowercase" /> to hide this attribute
          on their profile?
          <div className={classes.subTitle}>
            <strong>Note: </strong>
            Admins will still have the ability to see this value.
          </div>
        </div>
        <RadioGroup
          aria-label="Allow attribute to be privatized?"
          name="valueCanBePrivatized"
          className={classes.radioGroup}
          value={attributeCanBePrivatized.toString()} /* Radio Group only accepts strings */
          onChange={(e: any) => onChange({ valueCanBePrivatized: castBool(e.target.value) })}
        >
          <FormControlLabel
            className={classes.formControlLabel}
            value="true"
            control={<Radio />}
            label="Yes"
          />
          <FormControlLabel value="false" control={<Radio />} label="No" />
        </RadioGroup>
      </div>
    </>
  );
}

export default withStyles(styles)(AttributeRadioForm);
